import { render, staticRenderFns } from "./AssignDriver.vue?vue&type=template&id=5e3f20ee&"
import script from "./AssignDriver.vue?vue&type=script&lang=js&"
export * from "./AssignDriver.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports